



import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { requiredOnlyValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { postForgotPassword } from '@kasasa/kloans-common-ui/dist/consumer-app/services/kloans-authentication';

@Component(
	{
		validations: {
			username: requiredOnlyValidation.validations,
		},
	},
)
export default class ForgotPassword extends Vue {
	username = '';

	recoverBtn = true;

	get usernameErrors() {
		return requiredOnlyValidation.errors(this, 'username');
	}

	async recoverPassword() {
		this.$v.$touch();
		if (!this.$v.$invalid) {
			this.recoverBtn = false;
			try {
				await postForgotPassword({
					username: this.username.toLowerCase(),
				});
			} finally {
				sessionStorage.setItem('username', this.username);
				this.recoverBtn = true;
				this.$router.push({ name: 'forgotPasswordEmailSent' });
			}
		}
	}
}
